export default "__VITE_ASSET__Ct3_FKXJ__"